import React, { useState, useEffect } from "react";
import axios from "axios";
import { UsersListContext } from "./UsersListContext";

export default function UsersListProvider({ children }) {
  const [usersList, setUsersList] = useState([]);
  const [loadingUsersList, setLoadingUsersList] = useState(true);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_API_URL}/users`,
          {
            params: {
              page: 1,
              limit: 100,
              sortBy: "userName:asc",
            },
          }
        );

        const raw = Array.isArray(data) ? data : data.results || [];
        setUsersList(raw);
      } catch (err) {
        console.error("Failed to load users list:", err);
      } finally {
        setLoadingUsersList(false);
      }
    };

    fetchAllUsers();
  }, []);

  return (
    <UsersListContext.Provider value={{ usersList, setUsersList, loadingUsersList }}>
      {children}
    </UsersListContext.Provider>
  );
}
